import React from 'react'
import { Navigate } from 'react-router-dom'
import { isAdmin } from './LoginState'

interface RA {
    children: React.ReactNode
    redirectTo: string
}

const RequireAdminAuth: React.FC<RA> = ({ children, redirectTo }) => {
    let auth = isAdmin()

    return <>{auth ? children : <Navigate to={redirectTo} />}</>
}

export default RequireAdminAuth
